
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { CircularProgress } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Circular Progress`}</h1>
<p>{`Similar to `}<a parentName="p" {...{
        "href": "/component-kit/components/progress-bar"
      }}><inlineCode parentName="a">{`ProgressBar`}</inlineCode></a>{` but in a circle. It can display some data also in the middle.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { CircularProgress } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<CircularProgress percentage={0.6} />`} component={CircularProgress} mdxType="Playground">
  <CircularProgress percentage={0.6} mdxType="CircularProgress" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;